import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {Button, Col, Row} from "reactstrap";
import React, {useState} from "react";
import {createSubscription} from "./vatia-functions";
import {CircularProgress} from "@mui/material";
import {FormattedMessage} from "react-intl";

function StripeCreditCardForm(props)
{
    const stripe = useStripe();
    const elements = useElements();

    const [loaderSubscriptionCreate,setLoaderSubscriptionCreate] = useState(false);
    const [ccError, setCCError] = useState("")
    const [ccSuccess, setCCSuccess] = useState("")

    const handleSubmit = async (event) =>
    {
        event.preventDefault();

        setLoaderSubscriptionCreate(true);
        var result = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
        })
        .then((result) =>
        {
            if (result.error)
            {
                // console.log("error when creating card", result);
                // setCCError(result.error.message)
                // setCCSuccess("")
                return result.error.message;
            }
            else
            {
                // console.log("created payment method", result);
                return createSubscription({
                    data: props,
                    paymentMethodId: result.paymentMethod.id,
                    backendUrl: props.backendUrl,
                    userId: props.userId,
                });
            }
        })
        .catch((error) => {
            // console.log("error", error);
            // setCCError(error)
            // setCCSuccess("")
            return error;
         });

        if(result != null && result != "")
        {
           // router.reload(); // just reload page for the moment
            setCCError(result)
            setCCSuccess("")
            setLoaderSubscriptionCreate(false);
        }
        else
        {
            setLoaderSubscriptionCreate(false);
            props.setIsDone(true);
        }
    };

    const CARD_ELEMENT_OPTIONS = {
        style: {
            base: {
                color: "#32325d",
                // fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#aab7c4",
                },
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        },
    };

    const cardStyle = {
   width: "100%",
   height: 50,
   padding: 10, paddingTop: 15,
   border: "1px solid #C9C9C9",
   borderRadius: 4,
   boxSizing: "border-box",
   fontSize: 16,
   color: "#4D4D4D",
   boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)"
    }

    return (
        <Row>
            <form onSubmit={handleSubmit}>
                <Row style={{maxWidth:500,paddingLeft:29, paddingRight:10}}>
                    {ccError && ccError != "" ? <span style={{color:"red"}}>{ccError}<br/><br/></span> : null}
                    {ccSuccess && ccSuccess != "" ? <span style={{color:"green"}}>{ccSuccess}<br/><br/></span> : null}
                </Row>
                <Row style={{paddingLeft:10, paddingRight:10}}>
                    <Col xl={8} lg={9} md={9} sm={8} xs={8} style={{paddingTop:12, marginRight:0, paddingRight:0}}>
                        <div style={cardStyle}>
                            <CardElement options={CARD_ELEMENT_OPTIONS} style={{minHeight:400}}/>
                        </div>
                    </Col>
                    <Col xl={4} lg={3} md={3} sm={4} xs={4} style={{paddingRight:props.width>props.breakpoint ? 10 : 5, paddingLeft:props.width>props.breakpoint ? 10 : 10}}>
                        {loaderSubscriptionCreate ? <CircularProgress style={{color:"#495057", marginTop:15, marginLeft:30}} /> :
                            <Button style={{backgroundColor:"#f19800",border:0,borderRadius:4, color:"#fff", width: "100%", minWidth:125, height: 48,
                                fontSize: 12, fontWeight: 600, paddingTop:0, marginTop:13, textAlign:"center"}} type="submit" disabled={!stripe || loaderSubscriptionCreate}>
                                <FormattedMessage id={ 'abo.new.button.continue.subscribe' } defaultMessage={ 'Abonnieren'} />
                            </Button>}
                    </Col>
                </Row>
            </form>
        </Row>
    );
};

export default StripeCreditCardForm